'use strict';

/**
 *
 * @name: nownessApp.social
 *
 */

import DoubanShareDirective from './nn-douban-share.directive';
import FacebookShareDirective from './nn-facebook-share.directive';
import GooglePlusShareDirective from './nn-google-plus-share.directive';
import PinterestShareDirective from './nn-pinterest-share.directive';
import WhatsAppShareDirective from './nn-whatsapp-share.directive';
import QqShareDirective from './nn-qq-share.directive';
import RedditShareDirective from './nn-reddit-share.directive';
import StumbleuponShareDirective from './nn-stumbleupon-share.directive';
import TumblrShareDirective from './nn-tumblr-share.directive';
import TwitterShareDirective from './nn-twitter-share.directive';
import VkontakteShareDirective from './nn-vkontakte-share.directive';
import NnWechatQrCodeDirective from './nn-wechat-qr-code.directive';
import WeiboShareDirective from './nn-weibo-share.directive';
import SocialButtonDirective from './nn-social-button/nn-social-button.directive';
import NnMobileAppBanner from './nn-mobile-app-banner/nn-mobile-app-banner.directive';

const SocialModule = angular
  .module('nownessApp.social', [])
  .directive('doubanShare', DoubanShareDirective)
  .directive('facebookShare', FacebookShareDirective)
  .directive('googleplusShare', GooglePlusShareDirective)
  .directive('pinterestShare', PinterestShareDirective)
  .directive('whatsappShare', WhatsAppShareDirective)
  .directive('qqShare', QqShareDirective)
  .directive('redditShare', RedditShareDirective)
  .directive('nsSocialButton', SocialButtonDirective)
  .directive('stumbleuponShare', StumbleuponShareDirective)
  .directive('tumblrShare', TumblrShareDirective)
  .directive('twitterShare', TwitterShareDirective)
  .directive('vkontakteShare', VkontakteShareDirective)
  .directive('weiboShare', WeiboShareDirective)
  .directive('nnWechatQrCode', NnWechatQrCodeDirective)
  .directive('nnMobileAppBanner', NnMobileAppBanner);

export default SocialModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-social/nn-social.module.js